import React from 'react'

const InputRef = React.forwardRef(({className, ...props}, ref) => {
  return (
    <input
      ref={ref}
      className={`rounded border p-2 lg:p-4 ${className}`}
      style={{borderColor: '#ddd'}}
      {...props}
    />
  )
})

export { InputRef }
